import z from "zod/v4";

const fakeAgTableColSchema = z.object({
  align: z.enum(["text-left", "text-right", "text-center"]).optional(),
  label: z.string(),
  colSpan: z.number().optional(),
  id: z.string().optional(),
  columnWidth: z.string().optional(),
  tooltip: z.string().optional(),
});
export type FakeAgTableColDefinition = z.infer<typeof fakeAgTableColSchema>;

const fakeAgTableCellSchema = z.object({
  value: z.union([z.string(), z.number()]),
  id: z.string().optional(),
  colSpan: z.number().optional(),
  cellStyle: z.string().optional(),
  backgroundColor: z.string().optional(),
  textColor: z.string().optional(),
});

export type FakeAgTableCellDefinition = z.infer<typeof fakeAgTableCellSchema>;

export const fakeAgTableSchema = z.object({
  cols: z.array(fakeAgTableColSchema),
  rows: z.array(z.array(fakeAgTableCellSchema)),
});
